
<form [formGroup]="calendarAddressFilterForm" class="_calendar-address-filter-component">
    <p>{{ 'FILTERS.ADDRESS_FILTER.TITLE' | translate }}</p>
    <form-search-address label="{{ 'ADDRESS.SEARCH_ADDRESS' | translate }}" (selected)="onAddressSelected($any($event))" >    
    </form-search-address>
    <ng-container class="_current_address" *ngIf="currentAddress">
        <p class="_address">
           {{currentAddress | address}}
           <ion-icon src="./assets/icons/close-outline.svg" (click)="clearAddress()"></ion-icon>
        </p>
        
    </ng-container>

    <div class="_range-container" >
        <p class="_subtitle">{{ 'FILTERS.ADDRESS_FILTER.RANGE' | translate }}</p>
        <div class="_range">
            <ngx-slider 
                (userChangeEnd)="onAddressRangeChanged()"
                
                [options]="{
                floor: 1,
                ceil: 20,
                showTicks: true,
                showTicksValues: true,
                tickStep: 2,
                getTickColor: adjustRangeColor,
                getPointerColor: adjustRangeColor
            }" [formControl]="calendarAddressFilterForm.get('range') | cast" ></ngx-slider>
        </div>
    </div>

</form>
     

